import axiosClient from './axiosClient';

export const updateAdminProfile = (adminId, payload) =>
  axiosClient.put(`/api/admin/${adminId}`, payload);

export const updateAdminPassword = (adminId, payload) =>
  axiosClient.put(`/api/admin/${adminId}/password`, payload);

export const uploadAdminAvatar = (adminId, formData) =>
  axiosClient.post(`/api/admin/${adminId}/avatar`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const deleteAdminAvatar = (adminId) =>
  axiosClient.delete(`/api/admin/${adminId}/avatar`);
